<bspk-toggle-option [description]="description()" [label]="label()" [size]="size()">
  <bspk-radio [aria-label]="label()" [disabled]="disabled()" [invalid]="invalid()" [name]="name()" [value]="value()" [(checked)]="checked"/>
</bspk-toggle-option>
